module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"hu":{"title":"Média","sub-title":"Külső Médiamegjelenések"},"en":{"title":"Media","sub-title":"External Media Appearances"}}')
  delete Component.options._Ctor
}
